import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import CanNotAccess from './views/CanNotAccess.vue'
import tools from '@/tools'
import store from '@/store.js'

const Team = () => import('@/views/Team.vue')
const Flow = () => import('@/views/Flow.vue')
const Manage = () => import('@/views/Manage.vue')
const Establishment = () => import('@/views/Establishment.vue')
const GatheringHome = () => import('@/views/GatheringHome.vue')
const ConsultantLinks = () => import('@/views/ConsultantLinks.vue')
const Profile = () => import('@/views/Profile.vue')
const Laboratory = () => import('@/views/Laboratory.vue')
const Link = () => import('./views/Link.vue')
const MyPrompt = () => import('@/views/MyPrompt.vue')
const Webmail = () => import('@/views/Webmail.vue')
const WebmailDetail = () => import('@/views/WebmailDetail.vue')
const CallBackOutlook = () => import('@/views/CallBackOutlook.vue')


Vue.use(Router)

function intersect(a, b) {
    // var setB = new Set(b);
    // return [...new Set(a)].filter(x => setB.has(x));
    if (b == null) {
        return []
    }
    return a.filter(value => -1 !== b.indexOf(value));
}

var router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            redirect: function () {
                const profile = store.state.profile;
                if (!profile || !profile.permissions) return '/login';
                return find_available_route_for_user(profile.groups, profile.permissions);
            },
            meta: {
                authRequired: true,
                allowed_groups: null,
                needed_permissions: null,
            },
            children: [{
                path: '/team',
                name: 'team',
                component: Team,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_team"],
                }
            }, {
                path: '/team/:uid',
                name: 'team_detail',
                component: Team,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_team"],
                }
            }, {
                path: '/flow',
                name: 'flow',
                component: Flow,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_flow"],
                }
            }, {
                path: '/flow/:uid',
                name: 'flow_detail',
                component: Flow,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_flow"],
                }
            }, {
                path: '/manage/:uid?',
                name: 'manage',
                component: Manage,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_manage"],
                }
            }, {
                path: '/establishment/:uid?',
                name: 'establishment',
                component: Establishment,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_establishment"],
                }
            }, {
                path: '/profile',
                name: 'profile',
                component: Profile,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_import_review"],
                }
            }, {
                path: '/laboratory',
                name: 'laboratory',
                component: Laboratory,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_lab"],
                }
            }, {
                path: '/links',
                name: 'link',
                component: Link,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_links"],
                }
            },
                {
                    path: '/my-prompt',
                    name: 'MyPrompt',
                    component: MyPrompt,
                    meta: {
                        authRequired: true,
                        allowed_groups: null,
                        needed_permissions: ['game.can_access_my_prompt'],
                    }
                },
                {
                    path: '/webmail',
                    component: Webmail,
                    meta: {
                        authRequired: true,
                        allowed_groups: null,
                        needed_permissions: ['game.can_access_webmail'],
                    },
                },
                {
                    path: '/webmail/:id',
                    name: 'webmail-detail',
                    component: WebmailDetail,
                    meta: {
                        authRequired: true,
                        allowed_groups: null,
                        needed_permissions: ['game.can_access_webmail'],
                    },
                },
                {
                    path: '/my-prompt',
                    name: 'my-prompt',
                    component: MyPrompt,
                    meta: {
                        authRequired: true,
                        allowed_groups: null,
                        needed_permissions: ['game.can_access_my_prompt'],
                    },
                },
                {
                    path: '/external-links/:uid?',
                    name: 'consultantLinks',
                    component: ConsultantLinks,
                    meta: {
                        authRequired: true,
                        allowed_groups: ['consultants'],
                        needed_permissions: null,
                    }
                },
                {
                    path: '/manage',
                }
            ]
        }, {
            path: '/g/:establishment_uid?',
            name: 'gathering_home',
            component: GatheringHome,
            meta: {
                authRequired: true,
                allowed_groups: ['gathering_staff', 'establishment_staff'],
                needed_permissions: null,
            },
        }, {
            path: '/g/:establishment_uid/:review_uid?',
            name: 'gathering_review',
            component: GatheringHome,
            meta: {
                authRequired: true,
                allowed_groups: ['gathering_staff', 'establishment_staff'],
                needed_permissions: null,
            },
        }, {
            path: '*',
            redirect: function () {
                const profile = store.state.profile;
                if (!profile || !profile.permissions) return '/login';
                return find_available_route_for_user(profile.groups, profile.permissions);
            }
        }, {
            path: '/can-not-access',
            name: 'Can_not_access',
            component: CanNotAccess,
            meta: {
                authRequired: true,
                allowed_groups: null,
                needed_permissions: null,
            }
        }, {
            path: '/login:next',
            name: 'login:next',
            component: Login,
            meta: {
                authRequired: false,
                allowed_groups: null,
                needed_permissions: null,
            }
        }, {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                authRequired: false,
                allowed_groups: null,
                needed_permissions: null,
            }
        },
        {
            path: '/oauth/callback/outlook',
            name: 'oauth-callback-outlook',
            component: CallBackOutlook,
            meta: {
                authRequired: false,
            },
        },
    ]
})


function has_access(user_values, required_values) {
    if (required_values == null) return true
    return intersect(user_values, required_values).length > 0
}


function can_access_route(route, user_groups, user_permissions) {
    if (!route.meta) return false
    return (
        has_access(user_permissions, route.meta.needed_permissions) &&
        has_access(user_groups, route.meta.allowed_groups)
    )
}

function find_available_route_for_user(user_groups, user_permissions) {
    const excluded = ['login','g', 'home', 'webmail-detail', 'webmail']
    for (let route of router.options.routes) {
        const candidates = route.children ? route.children : [route]
        for (let r of candidates) {
            if (!excluded.includes(r.name) && can_access_route(r, user_groups, user_permissions)) {
                return r.path
            }
        }
    }
    return '/can-not-access'
}


router.beforeEach(function (to, from, next) {
    if (!store.state.authenticated && to.meta.authRequired) {
        // -- target path may need authentication
        router.push({name: "login", params: {"next": to.path}})
    } else {
        if (!store.state.authenticated || store.state.profile == null) {
            // -- force store initialiszation with profile
            next()
        } else {
            // -- if condition are not satisfied, find an ok route
            if (!can_access_route(to, store.state.profile.groups, store.state.profile.permissions)) {
                let firstAccessibleRoute = find_available_route_for_user(
                    store.state.profile.groups,
                    store.state.profile.permissions
                )
                router.push(firstAccessibleRoute)
            }

            // -- edge case on '/can-not-access', with a refresh we want our new access
            if (to.path === '/can-not-access') {
                let firstAccessibleRoute = find_available_route_for_user(
                    store.state.profile.groups,
                    store.state.profile.permissions
                )
                if (firstAccessibleRoute && firstAccessibleRoute !== '/can-not-access') {
                    router.push(firstAccessibleRoute)
                }
            }

            // -- if route is ok, check modified fields
            var field_check = tools.check_modified_fields(store)
            if (field_check.allow === true) {
                next()
            } else {
                store.dispatch("notify", {
                    text: field_check.notify_text,
                    seconds: 5,
                    level: "danger"
                })
            }
        }
    }
})

export default router
